<template>
  <AppTooltip :text="connected ? $t('general.liveConnected') : $t('general.liveDisconnected')" location="bottom">
    <template v-slot:activator="{ props }">
      <span v-bind="props" class="live-indicator">
        <span class="live-indicator__dot" :class="connected ? 'live-indicator__dot--connected' : 'live-indicator__dot--disconnected'" />
      </span>
    </template>
  </AppTooltip>
</template>

<script>
export default {
  name: 'LiveIndicator',

  props: {
    connected: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style scoped>
.live-indicator {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  cursor: default;
}

.live-indicator__dot {
  position: relative;
  display: block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

.live-indicator__dot--connected {
  background-color: rgb(var(--v-theme-success));
  animation: live-pulse-glow 2s ease-in-out infinite;
}

.live-indicator__dot--connected::after {
  content: '';
  position: absolute;
  inset: 0;
  border-radius: 50%;
  background-color: rgb(var(--v-theme-success));
  animation: live-pulse-ring 2s ease-out infinite;
}

.live-indicator__dot--disconnected {
  background-color: rgb(var(--v-theme-error));
  animation: live-pulse-glow 1s ease-in-out infinite;
}

@keyframes live-pulse-glow {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}

@keyframes live-pulse-ring {
  0% { transform: scale(1); opacity: 0.6; }
  100% { transform: scale(2.4); opacity: 0; }
}
</style>
